import React from "react";
import { formatDate } from "./utils";

const MessagesTab = ({ messages }) => (
  <div className="bg-white border border-line overflow-x-auto" data-testid="admin-messages-panel">
    <ul className="divide-y divide-line">
      {messages.length === 0 ? (
        <li className="px-5 py-8 text-mute text-center">No messages yet.</li>
      ) : (
        messages.map((m) => (
          <li key={m.id} className="px-5 py-5">
            <div className="flex items-center justify-between mb-2">
              <p className="font-medium">{m.name}</p>
              <span className="mono text-xs text-mute">{formatDate(m.created_at)}</span>
            </div>
            <p className="mono text-xs text-mute mb-2">{m.email}</p>
            <p className="text-sm leading-relaxed">{m.message}</p>
          </li>
        ))
      )}
    </ul>
  </div>
);

export default MessagesTab;
